import { Component } from "react";

import { GrClose } from "react-icons/gr";
import Strategy4InfoBox from "./strategy4InfoBox.jsx";
import Strategy4AddDialog from "./strategy4AddDialog.jsx";
import Strategy4LogsModal from "./strategy4LogsModal.jsx";
import Strategy4OrderbookModal from "./strategy4OrderbookModal.jsx";
import { FaInfo, FaTrash, FaPlay, FaPause, FaList, FaBook } from "react-icons/fa";

class Strategy4Conditions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addModalShow: false,
      infoBoxShow: false,
      infoBoxCondition: {},
      logsModalShow: false,
      ordersModalShow: false,
      selectedConditionId: null
    }

    this.updateIntervalID = null;
  }

  componentDidMount() {
    var intervalId = setInterval(() => this.props.getConditions(4), 1000);
    this.updateIntervalID = intervalId;
  }

  componentWillUnmount() {
    clearInterval(this.updateIntervalID);
    this.updateIntervalID = null;
  }

  showAddDialog = () => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.addModalShow = true;
      return newState;
    });
  }

  hideAddDialog = () => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.addModalShow = false;
      return newState;
    });
  }

  showInfoBox = condition => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.infoBoxShow = true;
      newState.infoBoxCondition = condition;
      return newState;
    });
  }

  closeInfoBox = () => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.infoBoxShow = false;
      newState.infoBoxID = null;
      return newState;
    });
  }

  showLogsModal = conditionId => {
    this.setState({
      logsModalShow: true,
      selectedConditionId: conditionId
    });
  }

  closeLogsModal = () => {
    this.setState({
      logsModalShow: false,
      selectedConditionId: null
    });
  }

  showOrdersModal = conditionId => {
    this.setState({
      ordersModalShow: true,
      selectedConditionId: conditionId
    });
  }

  closeOrdersModal = () => {
    this.setState({
      ordersModalShow: false,
      selectedConditionId: null
    });
  }

  render() {
    console.log(this.props.conditions);

    return (
      <div>
        <div className="card m-2">
          <header className="card-header has-text-centered">
            <h5 className="card-header-title">RSI Algo</h5>
          </header>

          <section className="card-content overflow-auto">
            <table className="table is-striped is-hoverable has-text-centered is-fullwidth">
              <thead>
                <tr>
                  <th align="center">ID</th>
                  <th align="center">Broker</th>
                  <th align="center">Scrip</th>
                  <th align="center">Status</th>
                  <th align="center">Ins</th>
                  <th align="center">Running P&L</th>
                  <th align="center">Booked P&L</th>
                  <th align="center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.props.conditions.map((condition, i) => (
                  <tr key={i}>
                    <th scope="row">{condition.id}</th>
                    <td align="center">{condition.brokerName}</td>
                    <td align="center">{condition.scrip}</td>
                    <td align="center">{condition.status}</td>
                    <td align="center">{condition.enteredIns}</td>
                    <td align="center">{condition.runningPnl}</td>
                    <td align="center">{condition.bookedPnl}</td>
                    <td>
                      {
                        condition.stopped ?
                        <button
                          className="button is-danger mx-2"
                          onClick={() => this.props.startCondition(condition.id, 4)}
                        >
                          <FaPlay />
                        </button> :
                        <button
                          className="button is-success mx-2"
                          onClick={() => this.props.stopCondition(condition.id, 4)}
                        >
                          <FaPause />
                        </button>
                      }
                      <button
                        className="button is-warning mx-2"
                        onClick={() => this.props.handleClosePositions(condition.id, 4)}
                      >
                        <GrClose />
                      </button>
                      <button
                        className="button is-danger mx-2"
                        onClick={() => this.props.handleConditionDelete(condition.id, 4)}
                      >
                        <FaTrash />
                      </button>
                      <button className="button is-info mx-2" onClick={() => this.showInfoBox(condition)}>
                        <FaInfo />
                      </button>
                      <button className="button is-dark mx-2" onClick={() => this.showLogsModal(condition.id)}>
                        <FaList />
                      </button>
                      <button className="button is-primary mx-2" onClick={() => this.showOrdersModal(condition.id)}>
                        <FaBook />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          <footer className="card-footer">
            <button className="card-footer-item button is-link" onClick={() => this.props.getConditions(4)}>Refresh</button>
            <button className="card-footer-item button is-primary" onClick={this.showAddDialog}>Add Condition</button>
          </footer>
        </div>

        <Strategy4AddDialog
          brokers={this.props.brokers}
          open={this.state.addModalShow}
          hideAddDialog={this.hideAddDialog}
          addCondition={this.props.addCondition}
        />
        <Strategy4InfoBox
          show={this.state.infoBoxShow}
          handleClose={this.closeInfoBox}
          condition={this.state.infoBoxCondition}
        />
        <Strategy4LogsModal
          show={this.state.logsModalShow}
          handleClose={this.closeLogsModal}
          conditionId={this.state.selectedConditionId}
          getConditionLogs={this.props.getConditionLogs}
        />
        <Strategy4OrderbookModal
          show={this.state.ordersModalShow}
          handleClose={this.closeOrdersModal}
          conditionId={this.state.selectedConditionId}
          getConditionOrders={this.props.getConditionOrders}
        />
      </div>
    );
  }
}

export default Strategy4Conditions;